
      var $parcel$global = globalThis;
    var $6a6b4b5ab5be324d$exports = {};
// Parcel picks the `source` field of the monorepo packages and thus doesn't
// apply the Babel config. We therefore need to manually override the constants
// in the app.
// See https://twitter.com/devongovett/status/1134231234605830144
$parcel$global.__DEV__ = false;
$parcel$global.__TEST__ = false;


//# sourceMappingURL=index.639e7478.js.map
